const workFlowMge = r => require.ensure([], () => r(require('@/page/workFlowMge/workFlowMge')), 'workFlowMge');
const workFlowList = r => require.ensure([], () => r(require('@/page/workFlowMge/workFlowList/workFlowList')), 'workFlowList');
const addWorkFlow = r => require.ensure([], () => r(require('@/page/workFlowMge/workFlowList/addWorkFlow')), 'addWorkFlow');
const editWorkFlow = r => require.ensure([], () => r(require('@/page/workFlowMge/workFlowList/editWorkFlow')), 'editWorkFlow');
const workFlowDetail = r => require.ensure([], () => r(require('@/page/workFlowMge/workFlowList/workFlowDetail')), 'workFlowDetail');

const expertInfoRouter = {
  path: '',
  name: '工作流管理',
  component: workFlowMge,
  meta: {
    icon: 'expertInfo',
    right: [],
    isShowMenu: true,
    keepAlive:true
  },
  children: [{
    path: '/workFlowList',
    component: workFlowList,
    name: '工作流管理',
    meta: {
      right: ['工作流管理'],
      isShowMenu: true,
      keepAlive:true
    },
  }, {
    path: '/addWorkFlow',
    component: addWorkFlow,
    name: '工作流新增',
    meta: {
      right: ['工作流新增'],
      isShowMenu: true,
      keepAlive:true
    },
  }, {
    path: '/editWorkFlow',
    component: editWorkFlow,
    name: '工作流编辑',
    meta: {
      right: ['工作流编辑'],
      isShowMenu: true,
      keepAlive:true
    },
  }, {
    path: '/workFlowDetail',
    component: workFlowDetail,
    name: '工作流详情',
    meta: {
      right: ['工作流详情'],
      isShowMenu: true,
      keepAlive:true
    },
  }]
};
export default expertInfoRouter;